import {CoinsSections_LatestAchievementSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/sections.types';
import {Button, COLORS, SPACING, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {CoinsMission} from '../CoinsMissions/CoinsMission';
import {useCoinsLatestAchievementsOpenedState} from './utils/useCoinsLatestAchievementsOpenedState';

export const CoinsLatestAchievements: React.FC<
  CoinsSections_LatestAchievementSection
> = ({title, achievements, ctaLabel}) => {
  const {open} = useCoinsLatestAchievementsOpenedState();

  return (
    <Section data-testid="coinsLatestAchievements">
      <TitleWrapper>
        <Text size="px16" weight="mediumHeavy">
          {title}
        </Text>
      </TitleWrapper>
      <RowList>
        {achievements.map((mission, index) => (
          <CoinsMission
            key={index}
            {...mission}
            data-testid="latestAchievement"
          />
        ))}
      </RowList>
      {ctaLabel && (
        <CTAWrapper>
          <CTAButton
            variant="secondary"
            onClick={() => open()}
            aria-label={undefined}
            data-testid="coinsLatestAchievementsCTA"
          >
            {ctaLabel}
          </CTAButton>
        </CTAWrapper>
      )}
    </Section>
  );
};

const Section = styled.div`
  &:before {
    content: '';
    position: absolute;
    left: -${SPACING['X.Lg']};
    top: -2px;
    width: calc(100% + ${SPACING['X.Lg']} * 2);
    height: ${SPACING['Y.Md']};
    background-color: ${COLORS['Fill.Grey.Primary']};
  }
  position: relative;
  display: flex;
  flex-direction: column;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${SPACING['Y.Xl']} 0 ${SPACING['Y.Lg']};
  gap: 4px;
`;

// Groups the achievement rows so CoinsMission's own row separator
// (border-bottom on :not(:last-child)) is scoped to the rows only — the
// last row becomes the real :last-child, so no separator bleeds onto the
// trailing CTA, which now sits outside this list.
const RowList = styled.div`
  display: flex;
  flex-direction: column;
`;

const CTAWrapper = styled.div`
  padding: 0 0 ${SPACING['Y.Xl']};
`;

const CTAButton = styled(Button)`
  &&& {
    width: 100%;
  }
`;
